import type { RouteObject } from 'react-router-dom';
import { lazyWithRetry } from '@repo/error';

import { ReservationExistsGuard } from '@features/account';
import { AuthGuard } from '@features/auth';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

const SpotTakenPage = lazyWithRetry(() => import('@features/reservationConflict/pages/SpotTakenPage'));

export const reservationConflictRoutes: RouteObject[] = [
  {
    element: <AuthGuard allowGuest />,
    children: [
      {
        path: ROUTE_PATHS[RouteName.ACCOUNT_RESERVATION_SPOT_TAKEN],
        element: <ReservationExistsGuard />,
        children: [
          {
            index: true,
            element: <SpotTakenPage />,
          },
        ],
      },
    ],
  },
];
